/* ============================================================
   Page panier — JS original (Stratégie 2)
   Quantité / suppression en AJAX via Section Rendering API
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var sectionId = root.dataset.sectionId;

    root.addEventListener('click', function (e) {
      var up = e.target.closest('[data-lf-qty-up]');
      var down = e.target.closest('[data-lf-qty-down]');
      var remove = e.target.closest('[data-lf-cart-remove]');
      if (remove) { e.preventDefault(); change(remove.dataset.key, 0); return; }
      if (up || down) {
        var input = (up || down).closest('[data-lf-qty]').querySelector('[data-lf-qty-input]');
        var cur = parseInt(input.value, 10) || 0;
        change(input.dataset.key, up ? cur + 1 : Math.max(0, cur - 1));
      }
    });

    /* Entree dans un champ de quantite soumettait le formulaire, dont le
       premier bouton est « Paiement » : le client partait au checkout en
       voulant changer une quantite. On valide la quantite sur place. */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-lf-qty-input]')) return;
      e.preventDefault();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-lf-qty-input]');
      if (!input) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      change(input.dataset.key, q);
    });

    /* La note ne partait qu'avec le formulaire, c'est-a-dire au moment
       de passer commande : la saisir puis changer une quantite ou
       quitter la page la perdait. On l'enregistre a la frappe, une fois
       la main levee. Delegation sur la racine : le contenu du panier est
       remplace a chaque mise a jour, une reference directe au champ
       deviendrait caduque. */
    var attente = null;
    root.addEventListener('input', function (e) {
      if (!e.target.closest('[data-lf-cart-note]')) return;
      clearTimeout(attente);
      attente = setTimeout(enregistrerNote, 700);
    });
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-lf-cart-note]')) return;
      clearTimeout(attente);
      enregistrerNote();
    });

    function enregistrerNote() {
      var champ = root.querySelector('[data-lf-cart-note]');
      if (!champ) return;
      fetch(window.lfRoutes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: champ.value })
      }).catch(function () {});
    }

    function texteErreur(data) {
      var brut = data && (data.description || data.errors || data.message);
      var repli = (window.lfStrings || {}).cartUpdateError || '';
      if (!brut) return repli;
      if (typeof brut === 'string') return brut;
      if (Array.isArray(brut)) return brut.join(' ');
      return Object.keys(brut).map(function (k) { return [].concat(brut[k]).join(' '); }).join(' ') || repli;
    }

    function erreurLigne(key, texte) {
      var lignes = root.querySelectorAll('.lf-cartpage__item[data-key]');
      for (var i = 0; i < lignes.length; i++) {
        if (lignes[i].dataset.key !== key) continue;
        var zone = lignes[i].querySelector('[data-lf-line-error]');
        if (zone) zone.textContent = texte || '';
        return;
      }
    }

    /* Le contenu est remplace a chaque mise a jour : le bouton ou le champ
       qui avait le focus disparaissait avec lui. On le retrouve par sa
       ligne et son role. */
    var ROLES = ['data-lf-qty-down', 'data-lf-qty-up', 'data-lf-qty-input', 'data-lf-cart-remove'];

    function decrireFocus() {
      var actif = document.activeElement;
      if (!actif || !root.contains(actif)) return null;
      var ligne = actif.closest('[data-key]');
      for (var i = 0; i < ROLES.length; i++) {
        if (actif.hasAttribute(ROLES[i]) && ligne) return { role: ROLES[i], cle: ligne.dataset.key };
      }
      return null;
    }

    function retablirFocus(d) {
      if (!d) return;
      var lignes = root.querySelectorAll('.lf-cartpage__item[data-key]');
      for (var i = 0; i < lignes.length; i++) {
        if (lignes[i].dataset.key === d.cle) {
          var cible = lignes[i].querySelector('[' + d.role + ']');
          if (cible) cible.focus({ preventScroll: true });
          return;
        }
      }
      var titre = root.querySelector('.lf-cartpage__title');
      if (titre) { titre.setAttribute('tabindex', '-1'); titre.focus({ preventScroll: true }); }
    }

    function remplacer(html) {
      var focus = decrireFocus();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-lf-cart-page-content]');
      var cur = root.querySelector('[data-lf-cart-page-content]');
      if (fresh && cur) cur.replaceWith(fresh);
      retablirFocus(focus);
    }

    function compteur(html) {
      var hd = new DOMParser().parseFromString(html, 'text/html');
      var fc = hd.querySelector('[data-lf-cart-count]');
      var cc = document.querySelector('[data-lf-cart-count]');
      if (fc && cc) cc.replaceWith(fc);
      /* Le tiroir est aussi present sur la page panier : sans ce relais, il
         gardait les quantites et le total d'avant la modification. */
      document.dispatchEvent(new CustomEvent('lf:cart:section', { detail: { html: html } }));
    }

    function rafraichir() {
      /* `window.lfRoutes` est pose par la mise en page avant tout script de
         section : le repli code en dur ne servait jamais, et il aurait
         justement servi au mauvais moment — sous un prefixe de langue ou
         un marche, « /cart » n'est pas l'adresse du panier. */
      var page = window.lfRoutes.cart;
      return fetch(page + '?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(remplacer);
    }

    function change(key, quantity) {
      root.classList.add('is-loading');
      fetch(window.lfRoutes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId + ',header' })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          var data = res.data;
          /* Au-dela du stock, l'API repond 422 sans rendu de section : rien
             n'etait remplace, le champ gardait la quantite demandee et le
             total ne bougeait plus. On relit le panier, puis on explique. */
          if (!res.ok || data.status) {
            return rafraichir().then(function () { erreurLigne(key, texteErreur(data)); });
          }
          if (data.sections && data.sections[sectionId]) remplacer(data.sections[sectionId]);
          if (data.sections && data.sections.header) compteur(data.sections.header);
          var ligne = (data.items || []).filter(function (it) { return it.key === key; })[0];
          if (quantity > 0 && ligne && ligne.quantity < quantity) {
            var modele = (window.lfStrings || {}).cartQuantityError || '';
            erreurLigne(key, modele.replace('[quantity]', ligne.quantity));
          }
        })
        .catch(function () {
          erreurLigne(key, (window.lfStrings || {}).cartUpdateError || '');
        })
        .then(function () {
          root.classList.remove('is-loading');
        });
    }
  }

  function boot() { document.querySelectorAll('[data-lf-cart-page]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
